import { render, staticRenderFns } from "./SubmitDisposal.vue?vue&type=template&id=496b0628"
import script from "./SubmitDisposal.vue?vue&type=script&lang=js"
export * from "./SubmitDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports